import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from '../../../../../helpers/CanDeactivate/dirty-component';
import { ConfigService } from '../../../../../helpers/config.service';
import { VendorsService } from '../../../services/vendors.service';

@Component({
  selector: 'app-approve-vendor-withdrawal-request',
  templateUrl: './approve-vendor-withdrawal-request.component.html',
  styles: ``
})
export class ApproveVendorWithdrawalRequestComponent  extends DirtyComponent implements OnInit {
  override formGroup!: FormGroup;
  loading: boolean = false;

  constructor(private _formBuilder: FormBuilder,
    translate: TranslateService,
    override dialogRef: MatDialogRef<ApproveVendorWithdrawalRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _config: ConfigService,
    private _vendorService:VendorsService) {
    super(translate)
  }


  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      request_id: new FormControl(this.data),
      transaction_number: new FormControl(''),
      transaction_file: new FormControl('')
    })

  }

  OnSubmit() {
    if (this.formGroup.invalid) {
      return;
    }
    this.loading = true;
    const formData = new FormData()
    formData.append("transaction_number", this.formGroup.value.transaction_number)
    formData.append("transaction_file", this.formGroup.value.transaction_file)
    formData.append("request_id", this.formGroup.value.request_id)
    this._vendorService.ApproveVendorWithdrawalRequest(formData).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        this._config.SusseccMessage(this.translate.instant("withdrawalRequests.Request is approved"))
      },
      error: (err: any) => {
        this.loading = false;

      }
    });
  }


  OnSelectFile(files: any) {
    this.formGroup.patchValue({ transaction_file: files[0] });
    this.formGroup.controls['transaction_file'].markAsDirty();
  }
}

